import { LedgerSettingsItem } from 'common/models'
import { isEqual } from 'lodash'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectAssetDetailPage } from 'store/asset/selectors'

export const useGetAssetLedger = (assetLedger?: LedgerSettingsItem) => {
  const { asset } = useSelector(selectAssetDetailPage, isEqual)

  return useMemo(() => {
    return asset?.fixed_asset_ledgers?.find(ledger => ledger.ledger_setting_id === assetLedger?.id)
  }, [asset, assetLedger])
}
